import jsPDF from "jspdf";
 
const generateDPDPCertificate = (userData, assessmentData, susanLogo, previewMode = false, exportFormat = 'pdf') => {
 
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });
 
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const centerX = pageWidth / 2;
 
  // ===== BACKGROUND (Light Blue) =====
  doc.setFillColor(248, 252, 248);
  doc.rect(0, 0, pageWidth, pageHeight, "F");
 
  // ===== BORDERS (dark blue) =====
  doc.setDrawColor(6, 28, 49);
  doc.setLineWidth(1.5);
  doc.rect(10, 10, pageWidth - 20, pageHeight - 20);
  doc.setLineWidth(0.3);
  doc.rect(13, 13, pageWidth - 26, pageHeight - 26);
 
  // ===== LOGO (SUSAN) TOP =====
  if (susanLogo) {
    try {
      const imgProps = doc.getImageProperties(susanLogo);
      const logoHeight = 25;
      const logoWidth = (imgProps.width * logoHeight) / imgProps.height;
      doc.addImage(
        susanLogo,
        "PNG",
        centerX - logoWidth / 2,
        30,
        logoWidth,
        logoHeight
      );
    } catch {
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(6, 28, 49);
      doc.text("SUSAN PORTAL", centerX, 30, { align: "center" });
    }
  } else {
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(6, 28, 49);
    doc.text("SUSAN PORTAL", centerX, 30, { align: "center" });
  }
 
  // ===== TITLE =====
  const titleY = 70;
  doc.setFontSize(35);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(6, 28, 49);
  doc.text("ServQual Certified DPDPA Fundamentals", centerX, titleY, { align: "center" });
 
  // ===== CERT TEXT =====
  doc.setFontSize(15);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "italic");
  doc.text("This certifies that", centerX, 85, { align: "center" }); 
 
  // ===== USER NAME =====
  const userName =
    userData?.name || userData?.["cognito:username"] || "Participant";
  doc.setFontSize(32);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(6, 28, 49);
  doc.text(userName.toUpperCase(), centerX, 106, { align: "center" });
  const nameWidth = doc.getTextWidth(userName.toUpperCase());
  doc.setDrawColor(6, 28, 49);
  doc.setLineWidth(0.5);
  doc.line(centerX - nameWidth / 2 - 8, 108, centerX + nameWidth / 2 + 8, 108);
 
  // ===== ACHIEVEMENT TEXT =====
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);
  doc.text(
    "Has successfully completed the Certificate Course and Examination on the",
    centerX,
    118,
    { align: "center" }
  );
  doc.setFontSize(15);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(6, 28, 49);
  doc.text(
    "Digital Personal Data Protection Act, 2023",
    centerX,
    127,
    { align: "center" }
  );
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);
  doc.text(
    "demonstrating strong knowledge of data protection and compliance requirements.",
    centerX,
    134,
    { align: "center" }
  );
 
  // ===== PERCENTAGE SCORED =====
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);
  doc.text(
    `Percentage Scored: ${assessmentData.percentage}%`,
    centerX,
    145,
    { align: "center" }
  );
 
  // ===== DATE (LEFT BOTTOM) =====
  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "normal");
  doc.text(
    `Date of Issue: ${currentDate}`,
    25,
    pageHeight - 32,
    { align: "left" }
  );
 
  // ===== WEBSITE LINK (RIGHT BOTTOM CORNER) =====
 // ===== WEBSITE LINK (SAME LINE AS DATE - RIGHT SIDE) =====
doc.setFontSize(9);
doc.setTextColor(0, 0, 0);
doc.setFont("helvetica", "normal");
doc.text(
  "https://srql.com",
  pageWidth - 25,
  pageHeight - 32,
  { align: "right" }
);

 
  // ===== CERTIFICATE ID =====
  const certificateId = `DPDP-${Date.now()}-${Math.random()
    .toString(36)
    .substr(2, 6)
    .toUpperCase()}`;
  doc.setFontSize(6);
  doc.setTextColor(80, 80, 80);
  doc.setFont("courier", "normal");
  doc.text(`Certificate ID: ${certificateId}`, centerX, pageHeight - 20, {
    align: "center",
  });
 
  // ===== FOOTER =====
  doc.setFontSize(7);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(6, 28, 49);
  doc.text(
    "This certificate is digitally generated. No Signature Required. Required Passing Percentage is 75%",
    centerX,
    pageHeight - 15,
    { align: "center" }
  );
 
  // ✅ FIXED: Return PDF based on mode & format
 // ✅ Return PDF based on mode & format
if (previewMode) {
  // Preview mode - return blob URL for iframe preview
  const pdfBlob = doc.output('blob');
  return URL.createObjectURL(pdfBlob);
}
 
if (exportFormat === 'blob') {
  // NEW: pure Blob for email sending (no download, no DOM)
  const pdfBlob = doc.output('blob');
  return pdfBlob;
} else if (exportFormat === 'png') {
  // ✅ PNG EXPORT (existing logic)
  try {
    const pdfDataUrl = doc.output('dataurlstring');
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
   
    iframe.onload = function() {
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        const canvas = iframeDoc.createElement('canvas');
        const context = canvas.getContext('2d');
       
        canvas.width = 2480;
        canvas.height = 1754;
       
        const img = new Image();
        img.onload = function() {
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(img, 0, 0, canvas.width, canvas.height);
         
          canvas.toBlob(function(blob) {
            if (blob) {
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = `DPDP_Certificate_${userName.replace(/\s+/g, "_")}_${currentDate.replace(/\s+/g, "_")}.png`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              console.log('✅ PNG Certificate downloaded successfully!');
            }
            document.body.removeChild(iframe);
          }, 'image/png', 1.0);
        };
       
        img.onerror = function() {
          console.error('❌ Failed to load PDF as image');
          document.body.removeChild(iframe);
          doc.save(`DPDP_Certificate_${userName.replace(/\s+/g, "_")}_${currentDate.replace(/\s+/g, "_")}.pdf`);
        };
       
        img.src = pdfDataUrl;
      } catch (error) {
        console.error('❌ PNG conversion error:', error);
        document.body.removeChild(iframe);
        doc.save(`DPDP_Certificate_${userName.replace(/\s+/g, "_")}_${currentDate.replace(/\s+/g, "_")}.pdf`);
      }
    };
   
    iframe.src = 'about:blank';
   
  } catch (error) {
    console.error('❌ PNG export failed:', error);
    doc.save(`DPDP_Certificate_${userName.replace(/\s+/g, "_")}_${currentDate.replace(/\s+/g, "_")}.pdf`);
  }
 
  return 'png_download_initiated';
 
} else {
  // Default: download PDF
  const fileName = `DPDPA_Certificate_${userName.replace(
    /\s+/g,
    "_"
  )}_${currentDate.replace(/\s+/g, "_")}.pdf`;
  doc.save(fileName);
  return null;
}
 
};
 
export default generateDPDPCertificate;